import { inject, provide } from 'vue';

import type { IGroupItemProvide } from '@components/composable';
import type { ComputedRef, InjectionKey, Ref } from 'vue';

export interface ICdsSlideViewProvide {
  rootRef: Ref<HTMLElement | undefined>;
  transition: ComputedRef<undefined | string>;
  transitionCount: Ref<number>;
  transitionHeight: Ref<undefined | string>;
  isReversed: Ref<boolean>;
}

export const CdsSlideViewSymbol: InjectionKey<ICdsSlideViewProvide> = Symbol.for('cds:slide-view');
export const CdsSlideViewGroupSymbol: InjectionKey<IGroupItemProvide> = Symbol.for('cds:slide-view-group');

export const useProvideSlideView = (data: ICdsSlideViewProvide) => {
  provide(CdsSlideViewSymbol, data);
};

export const useInjectSlideView = () => {
  return inject(CdsSlideViewSymbol, {} as ICdsSlideViewProvide);
};
